<template lang="pug">
  form(@submit.prevent="next")
    p.text-large - Valores do Documento
    .columns
      .column.col-6.col-md-12(v-for="(valor, index) in resource.valores" :key="valor.tipo")
        form-group(:label="valor.titulo")
          doc-valor.form-input(v-model="resource.valores[index]")
    .pt-2
      .divider
      button.btn.btn-primary
        btn-content(name="next")
</template>

<script>
import mixin from './mixin'

export default {
  mixins: [mixin],
}
</script>
